import styled from "@emotion/styled"
import { Box, Breadcrumbs } from "@mui/material"
import Link from "next/link"
import React from "react"
import { sharedColors } from "ui/theme/colors"
import { NewText } from "ui"

const StyledIconWithText = styled.div`
display: flex;
align-items: center;
gap: 3px;
text-decoration: underline;
`


type HomePageLinkUIProps = {
    title: string
    icon: React.ReactNode
}
const HomePageLinkUI: React.FC<HomePageLinkUIProps> = ({ title, icon }) => {
    return (
        <StyledIconWithText>
            {icon}
            <NewText
                component="p"
                desktopFontSize={12}
                desktopFontWeight="400"
                desktopLineHeight="150%"
                color={sharedColors.blue}
            >
                {title}
            </NewText>
        </StyledIconWithText>
    );
};
export default HomePageLinkUI;